export const CLIENT_NAME = 'client_name';
export const CLIENT_RUT = 'client_rut';
export const CLIENT_EMAIL = 'client_email';
export const CLIENT_ACCOUNTS = 'client_accounts';
export const SHARE_VALUES = 'share_values';
export const NEW_USER = 'new_user';
export const PENSIONED = 'pensioned';
export const SELECTED_BOND = 'selected_bond';
export const CHANGE_FUND_ACCOUNT = 'change_fund_account';
export const ROUTE_CHANGE_FOUND_VOUCHER = 'route_change_fund_voucher';
export const WITHDRAW_CONFIGURATION = 'withdraw_config';
export const WITHDRAW_CONDITIONS_STORAGE = 'withdraw_conditions';
export const PAYMENT_METHOD ='payment_method';
export const SELECTED_ACCOUNT = 'selected_account';
export const SELECTED_ACCOUNT_WITHDRAW = 'selected_account_withdraw';
export const SELECTED_INDEX = 'selected_index';
export const SELECTED_INDEX_WITHDRAW = 'selected_index_withdraw';
export const REQUEST_CDF = 'request_cdf';
export const APV_MF_STATUS = 'apv_mf_status';
export const APV_MF_ACTIVE = 'mf_apv_activated';
export const APV_MF_INACTIVE = 'mf_apv_deactivated';
export const PASSWORD_VALIDATION_CONFIG = 'password_validation_config';
export const ACCOUNTS = 'accounts';
export const CLIENT_PROFIT_AND_CONTRIBUTIONS = 'client_profit_and_contributions';
export const ACCOUNTS_CONF = 'accounts_conf';
export const ACCOUNTS_CONDITIONS = 'accounts_conditions';
export const RECOGNITION_BONDS = 'recognition_bonds';
export const PENDING_TRANSACTIONS = 'pending_transactions';
export const LAST_MOVEMENTS = 'last_movements';
export const PROFILABILITY = 'profilability';
export const GLOBAL_PROFILABILITY = 'global_profitability';
export const DISTRIBUTE_FUNDS_RESULT = 'distribute_funds_result';
export const EXPERIENCE_SURVEY_STARTED = 'experience_survey_started';
export const NORMATIVE_PROFITABILITY = 'normative_profitability';
export const TYPE_SECURITY_KEY = 'type_security_key';
export const BASIC_CLIENT_INFO = 'basic_client_info';
export const SINGLE_ACCOUNT_VIEW = 'single_account_view';
export const WITHDRAW_BALANCES = 'withdraw_balances';
export const PRODUCT_TYPE = 'product_type';
export const WITHDRAW_ADDED_ACCOUNT = 'withdraw_added_account';
export const WITHDRAW_DIGITAL_ACCOUNT = 'withdraw_digital_account';
export const WITHDRAW_INFO_VOUCHER = 'withdraw_info_voucher';
export const ACTIVATE_SELECTION_ACCOUNT = 'activate_selection_account';
export const TYPE_ERROR_GENERIC = 'type_error-generic';
export const ULTIMAS_12_COTIZACIONES = 'last_movements_CCO_12';
export const PENSION_EN_TRAMITE ='pension_in_process'
